<template>
    <vx-card title="Purchase Order Approval Requests">
        <div class="flex vx-input-group">
            <vs-tabs :value="activeTab">
                <vs-tab label="Waiting">
                    <tab-waiting></tab-waiting>
                </vs-tab>
                <vs-tab label="Inquired">
                    <tab-inquired></tab-inquired>
                </vs-tab>
                <vs-tab label="Approved">
                    <tab-approved></tab-approved>
                </vs-tab>
                <vs-tab label="Rejected">
                    <tab-rejected></tab-rejected>
                </vs-tab>
            </vs-tabs>
        </div>
    </vx-card>
</template>
<script>
import TabApproved from "./TabApproved.vue";
import TabRejected from "./TabRejected.vue";
import TabWaiting from "./TabWaiting.vue";
import TabInquired from "./TabInquired.vue";
export default {
    components: {
        TabApproved,
        TabRejected,
        TabWaiting,
        TabInquired,
    },
    data() {
        return {
            activeTab: sessionStorage.getItem('activeTabPO') ? sessionStorage.getItem('activeTabPO') : "0",
        }
    },
    methods: { },
    mounted(){
        console.log("index ===== ", sessionStorage.getItem('activeTabPO'))
    }
}
</script>
